/**
 * Device sessions hooks (React Query)
 *
 * The signed-in devices of the current user. The revoke mutation refetches
 * the list whether it succeeds or fails: a 404 means the list was stale. The
 * "sign out all other devices" mutation also refetches the list when it ends.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import {
	listDeviceSessions,
	revokeDeviceSession,
	revokeOtherDeviceSessions,
} from "../services/sessions-api.service";

export function useDeviceSessions() {
	return useQuery({
		queryKey: queryKeys.sessions.list(),
		queryFn: listDeviceSessions,
	});
}

export function useRevokeDeviceSession() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (sessionId: string) => revokeDeviceSession(sessionId),
		onSettled: () =>
			queryClient.invalidateQueries({ queryKey: queryKeys.sessions.list() }),
	});
}

export function useRevokeOtherDeviceSessions() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: revokeOtherDeviceSessions,
		onSettled: () =>
			queryClient.invalidateQueries({ queryKey: queryKeys.sessions.list() }),
	});
}
